import { Block, component } from "../../../scripts/core/Component";
import { Field } from "../field/index";
import serialize from "form-serialize";

@component("form")
class Form extends Block {
  constructor(context) {
    super(context);

    this.fieldList = this.list(Field);

    this.action = this.el.getAttribute("action");

    this.csrfInput = this.el.querySelector('input[name="csrfmiddlewaretoken"]');
    this._csrf = "";
    if (this.csrfInput) {
      this._csrf = this.csrfInput.value;
    }
  }

  validate() {
    this.fieldList.forEach(field => {
      console.log(field);
      if (!field.validate()) return false;
    });

    return true;
  }

  submit(validate) {
    if (validate !== false) {
      if (!this.validate()) {
        return Promise.reject("From is not valid");
      }
    }

    let data = serialize(this.el, { hash: true });
    console.log(data);

    let jsonData = JSON.stringify(data);

    return fetch(this.action, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": this._csrf,
        "X-Requested-With": "XMLHttpRequest"
      },
      body: jsonData
    })
      .then(this.checkStatus)
      .then(this.toJson)
      .then(response => {
        if (response.error) {
          throw new Error(response.message);
        }
        return response.data;
      });
  }

  checkStatus(response) {
    console.log(response);
    if (response.status >= 200 && response.status < 300) {
      return response;
    } else {
      let error = new Error(response.statusText);
      error.response = response;
      throw error;
    }
  }

  toJson(response) {
    return response.json();
  }

  reset() {
    this.el.reset();
  }
}

export { Form };



// WEBPACK FOOTER //
// ./components/ui/form/index.js